import React, { useEffect, useState } from 'react';
import { Route, Routes, useParams } from 'react-router-dom';
import { Container, Loader, Tabs } from '@itds/elements/index.js';

import Lead from '@brokerage/pages/agencies/leads/Lead';
import Quote from '@brokerage/pages/agencies/leads/Quote';

import H1 from '@brokerage/components/H1';

import { Api } from '@brokerage/utils/Api';

export const Show = () => {
  const params = useParams();

  const [loading, setLoading] = useState(true);
  const [quote, setQuote] = useState();
  const [lead, setLead] = useState();

  useEffect(() => {
    Api.loadLead(params.lead_id).then(({ data }) => {
      setLead(data);

      if (data.quote_id) {
        Api.loadQuote(data.quote_id).then(({ data }) => {
          setQuote(data);
          setLoading(false);
        });
      } else {
        setLoading(false);
      }
    });
  }, []);

  const child_props = {
    quote,
    lead
  };

  return loading ? (
    <Loader />
  ) : (
    <Container>
      <H1>{lead && lead.guid}</H1>

      <div style={{ display: 'flex' }}>
        <Tabs
          tabs={[
            {
              label: 'Lead',
              to: ' ',
              isActive: !window.location.hash.includes('quote')
            },
            {
              label: 'Quote',
              to: 'quote',
              isActive: window.location.hash.includes('quote')
            }
          ]}
          vertical={true}
        />

        <div style={{ width: '79%', paddingLeft: 40 }}>
          <Routes>
            <Route element={<Lead {...child_props} />} index={true} />
            <Route element={<Quote {...child_props} />} path='quote' />
          </Routes>
        </div>
      </div>
    </Container>
  );
};
